import {store} from "../../store";
import {scoringAccuracyTipsModalSlice} from "./ScoringAccuracyTipsModalSlice";

export const scoringAccuracyTipsModalStore = {
  // State modifiers
  setLastTimeUserOpenedScoreModalForAudioScoring: () => {
    store.dispatch((scoringAccuracyTipsModalSlice.actions.lastTimeUserOpenedScoreModalForAudioScoringReducer(Date.now())));
  },
  setLastTimeThisTipWasDisplayed: () => {
    store.dispatch((scoringAccuracyTipsModalSlice.actions.lastTimeThisTipWasDisplayedReducer(Date.now())));
  },
  setHasUserOptedToHideThisTip: () => {
    store.dispatch((scoringAccuracyTipsModalSlice.actions.hasUserOptedToHideThisTipReducer(true)));
  },

  // Getters
  getHasUserWaited24HoursBetweenTheLastTimeTheySawThisTipAndTheirLastAudioScore(): boolean {
    const lastTimeUserOpenedScoreModalForAudioScoring = scoringAccuracyTipsModalSlice.selectors.lastTimeUserOpenedScoreModalForAudioScoringSelector(store.getState());
    const lastTimeThisTipWasDisplayed = scoringAccuracyTipsModalSlice.selectors.lastTimeThisTipWasDisplayedSelector(store.getState());
    const oneDayInMilliseconds = 1000 * 60 * 60 * 24;
    return lastTimeThisTipWasDisplayed + oneDayInMilliseconds < lastTimeUserOpenedScoreModalForAudioScoring;
  },
  getHasUserOptedToHideThisTip: (): boolean => scoringAccuracyTipsModalSlice.selectors.hasUserOptedToHideThisTipSelector(store.getState()),
}
